<template>
	<BaseCmsPage @load="onPageLoad">
		<ClientOnly>
			<WebshopCheckoutWrapper>
				<div v-if="bankartHold == 1" class="form-loading form-loading-bankart">
					<UiLoader />
					<div class="form-loading-bankart-text">
						<BaseCmsLabel code="bankart_hold_loader" tag="span" />
					</div>
				</div>
				<template v-else>
					<div v-if="orderData" class="thank-you">
						<h1 class="thank-you-title">
							<template v-if="orderData?.customer?.first_name">{{ orderData.customer.first_name }}, </template>
							<BaseCmsLabel code="thank_you_title" />
						</h1>
						<p class="thank-you-desc-email" v-html="labels.get('thank_you_email').replace('$e', orderData?.customer?.email)"></p>

						<div v-if="orderData?.cart?.payments?.selected[0]?.code == 'opca_uplatnica'" class="global-warning thank-you-trr">
							<BaseCmsLabel code="thank_you_trr_info" tag="div" class="thank-you-trr-cnt" />
						</div>
						<div v-if="orderData?.cart?.payments?.selected[0]?.code == 'digitalni_bon'" class="global-warning thank-you-trr">
							<BaseCmsLabel code="thank_you_digitalni_bon_info" tag="div" class="thank-you-trr-cnt" />
						</div>

						<div class="thank-you-info">
							<div class="thank-you-info-item">
								<span class="thank-you-info-item-label"><BaseCmsLabel code="order_id" />:</span>
								<strong>{{ orderData?.cart?.order_id }}</strong>
							</div>
							<div class="thank-you-info-item">
								<span class="thank-you-info-item-label"><BaseCmsLabel code="payment_solution" />:</span>
								<strong>
									<span v-for="(paymentSelected, index) in orderData?.cart?.payments?.selected" :key="paymentSelected.id"> <span v-if="index > 0"> + </span>{{ paymentSelected.title }} </span>
								</strong>
							</div>
							<template v-if="additionalPaymentRoute != 1">
								<div class="thank-you-info-item">
									<span class="thank-you-info-item-label"><BaseCmsLabel code="shipping" />:</span>
									<strong v-for="shipping in orderData?.total?.extra_items" :key="shipping.index">
										<span v-if="shipping.total > 0"><BaseUtilsFormatCurrency :price="shipping.total" /></span>
										<span v-else class="green"><BaseCmsLabel code="free" /></span>
									</strong>
								</div>
							</template>
							<div class="thank-you-info-item">
								<span class="thank-you-info-item-label">
									<template v-if="additionalPaymentRoute == 1"><BaseCmsLabel code="thank_you_total_additpayment" />:</template>
									<template v-else><BaseCmsLabel code="thank_you_total" />:</template>
								</span>
								<strong v-if="orderData?.total?.base"><BaseUtilsFormatCurrency :price="orderData.total.base + orderData.total.tax" /></strong>
								<strong v-else class="green"><BaseCmsLabel code="free" /></strong>
							</div>
						</div>

						<div v-if="!orderData?.customer?.user_id" class="thank-you-signup">
							<BaseAuthUser v-slot="{urls}">
								<BaseCmsLabel code="thank_you_signup_title" tag="div" class="thank-you-signup-title" />
								<div class="thank-you-signup-content">
									<BaseCmsLabel code="thank_you_signup" tag="div" />
									<NuxtLink :to="urls.auth_signup" class="btn btn-outline btn-thank-you-signup"><BaseCmsLabel code="create_account" tag="span" /></NuxtLink>
								</div>
							</BaseAuthUser>
						</div>
						
						<div class="wc-selected-shippings" v-if="orderData?.parcels?.length">
							<div class="wc-selected-shippings-title">
								<BaseCmsLabel code="packages_title" />
							</div>
							<div class="wc-selected-shippings-content">
								<template v-for="parcel in orderData?.parcels" :key="parcel.number">
									<WebshopCheckoutPanel :title="'Paket ' + parcel.number + ' od ' + orderData?.parcels?.length">
										<div class="wc-package" v-if="parcel.shipping?.selected">
											<p class="wc-package-title">{{ parcel.shipping.selected.title }} <span v-if="parcel.shipping.selected.shipping_price"><BaseUtilsFormatCurrency :price="parcel.shipping.selected.shipping_price" /></span></p>
											<div class="items" v-if="parcel.items?.length">
												<template v-for="item in parcel.items" :key="item.id">
													<p class="wc-package-item">
														{{ item.item.title }}
													</p>
												</template>
											</div>
											<p class="wc-package-info">
												<template v-if="parcel.shipping?.selected?.preorder_package == true && parcel.shipping?.selected?.min_date">predvidoma <BaseUtilsFormatDate :date="parcel.shipping.selected.min_date" /></template>
												<template v-else-if="parcel.shipping?.selected?.code == 'hitra_dostava'"><BaseCmsLabel code="wc_shipping_hitra_dostava_info" /></template>
												<template v-else>
													<template v-if="parcel.shipping?.selected?.min_date && parcel.shipping?.selected?.max_date">predvidoma od {{ formatDateLong(parcel.shipping.selected.min_date) }} do {{ formatDateLong(parcel.shipping.selected.max_date) }}</template>
												</template>
											</p>
											<div class="wc-package-seller" v-if="parcel.parcel_name">
												<BaseCmsLabel code="seller_item_title" /> {{ parcel.parcel_name }}
											</div>
										</div>
									</WebshopCheckoutPanel>
								</template>
							</div>
						</div>
						<!--<WebshopPackage :review="true" mode="thankyou" :thankyouData="orderData" />-->

						<div class="thank-you-continue">
							<NuxtLink to="/" class="btn thank-you-continue-btn"><BaseCmsLabel code="thank_you_continue_shopping" /></NuxtLink>
						</div>
					</div>
				</template>
			</WebshopCheckoutWrapper>
			<template #fallback>
				<UiLoader class="spacing" />
			</template>
		</ClientOnly>
	</BaseCmsPage>
</template>

<script setup>
	const apiRoutes = useApiRoutes();
	const webshop = useWebshop();
	const endpoints = useEndpoints();
	const labels = useLabels();
	const {gtmTrack} = useGtmBB();
	const {generateThumbs} = useImages();
	const {formatDateLong} = useUtilsBB();
	const { bankartHold, additionalPaymentRoute, orderSuccess, orderData, paymentError } = useCheckout();

	let urlAddPayment = false;

	// generate thumbs for all parcel images
	async function generateItemImages() {
		if (orderData.value.parcels?.length) {
			orderData.value.parcels.forEach(async parcel => {
				const parcelItems = parcel.items;

				if (parcelItems?.length) {
					// move image to parent object so generateThumbs can find it
					parcelItems.forEach(item => {
						item.image = item.item.image;
					});

					await generateThumbs({
						data: parcelItems,
						preset: 'cartPackage'
					});
				}
			});
		}
	}

	function onPageLoad(data) {
		if(!data) return;
		gtmTrack('virtualPageview', {
			url: data?.url || '',
			title: data?.title || '',
		});
	}

	//affiliate lite
	let affiliateLite = ref(null);
	const affiliateParameters = {
		"CID": 1562655,
		"TYPE": 424487,
		"METHOD": 'S2S',
	};

	function hasCookie(cookieName, value) {
		if (typeof document !== 'undefined') {
			const cookies = document.cookie.split(';');
			for (let i = 0; i < cookies.length; i++) {
				const cookie = cookies[i].trim();
				if (cookie.startsWith(cookieName + '=')) {
					affiliateLite.value = cookie.substring('affiliate_lite='.length, cookie.length);;
					return true;
				}
			}
		}
		return false;
	}

	let intervalCallOrderStatus;
	onMounted(async () => {
		const url = window.location.href;
		const searchParams = new URL(url).searchParams;

		if(searchParams.get('webshopadditionalpayment')) {
			urlAddPayment = true;
		}

		if(searchParams.get('hold')) {
			//FIXME INTEG provjeriti, vjerojatno nepotrebno
			let bankartHoldUrl = searchParams.get('hold');
			if(bankartHoldUrl == 1) {
				bankartHold.value = 1;

				let urlId = searchParams.get('order_identificator');
				urlId = urlId.replace("|", '-').replace("|webshoporder", '').replace("|webshopadditionalpayment", '').replace("|webshop", '');

				const webshopOrderId = (urlAddPayment) ? endpoints.get('_get_hapi_webshop_additionalpayment_status') : endpoints.get('_get_hapi_webshop_order_status');
				const webshopOrder = webshopOrderId.replace("%ID%-%CODE%", urlId)

				async function callOrderStatus() {
					await useApi(webshopOrder, {method: 'GET'})
					.then(async (res) => {
						if(res.success) {
							clearInterval(intervalCallOrderStatus);
							orderSuccess.value = 0;
							paymentError.value = null;
							if(urlAddPayment) {
								const navigationResult = await navigateTo({path: apiRoutes.getAppUrl('webshop_additionalpayments_thank_you'), query: {order_identificator: urlId}});
								if(!navigationResult) {
									bankartHold.value = 0;
								}
							} else {
								const navigationResult = await navigateTo({path: apiRoutes.getAppUrl('webshop_thank_you'), query: {order_identificator: urlId}});
								if(!navigationResult) {
									bankartHold.value = 0;
								}
								if(orderData.value && orderData.value.cart?.order_id) {
									const order_ep = endpoints.get('_put_hapi_webshop_order');
									const order = order_ep.replace("%ID%-%CODE%", urlId)
									if(res.data.extra_data_certified_shop == null) {
										setTimeout(() => {
											var smdObject = {
											Key: "Slo_862",
											Type: "order",
											OrderId: "",
											Products: []
											};
											var smdWrapper = document.createElement("script");
											smdWrapper.id = "_cpxTag";
											smdWrapper.type = "text/javascript";
											smdWrapper.src = "https://cpx.smind.si/Log/LogData?data=" + encodeURIComponent(JSON.stringify(smdObject));
											var smdScript = document.getElementsByTagName("script")[0];
											smdScript.parentNode.insertBefore(smdWrapper, smdScript);
										}, 5000);

										await useApi(order, {method: 'PUT', body: {extra_data_certified_shop: true}},{lang: false});
									}
									if(res.data.extra_data_ec_purchase == null) {
										let gtmShipping = 0
										let gtmCoupon = 0
										if(orderData.value && orderData.value.total?.extra_items) {
											orderData.value?.total.extra_items?.find(el => {
												if(el.type == 'shipping') {
													gtmShipping = el.base
												}
												if(el.type == 'coupon') {
													gtmCoupon = el.base
												}
											})
										}
										gtmTrack('purchase', {
											cart: orderData.value,
											'transaction_id': orderData.value.cart?.order_id,
											'value': orderData.value.total?.base + orderData.value.total?.tax,
											'tax': orderData.value.total?.tax,
											'shipping': gtmShipping,
											'coupon': gtmCoupon
										});

										await useApi(order, {method: 'PUT', body: {extra_data_ec_purchase: true}},{lang: false});
									}
								}
							}
						} else if(res.success == false && res.data.next_view != null) {
							clearInterval(intervalCallOrderStatus);
							orderSuccess.value = 0;
							paymentError.value = res.data || null;
							if(urlAddPayment) {
								const navigationResult = await navigateTo({path: apiRoutes.getAppUrl('webshop_payment_new'), query: {order_identificator: urlId, webshopadditionalpayment: '1'}});
								if(!navigationResult) {
									bankartHold.value = 0;
								}
							} else {
								const navigationResult = await navigateTo({path: apiRoutes.getAppUrl('webshop_payment_new'), query: {order_identificator: urlId}});
								if(!navigationResult) {
									bankartHold.value = 0;
								}
							}
						}
					})
				}
				intervalCallOrderStatus = setInterval(callOrderStatus, 2000);
			}
		}

		if(urlAddPayment == true && searchParams.get('webshopadditionalpayment')) {
			additionalPaymentRoute.value = 1;
			let urlId = searchParams.get('order_identificator');
			urlId = urlId.replace("|", '-').replace("|webshoporder", '');

			const webshopOrderId = endpoints.get('_get_hapi_webshop_additionalpayment');
			const webshopOrder = webshopOrderId.replace("%ID%-%CODE%", urlId);

			async function fetchOrderData() {
				await useApi(webshopOrder, {method: 'GET'})
				.then(async (res) => {
					orderData.value = res.data;
					generateItemImages();
				})
			}

			fetchOrderData();
		}

		if(urlAddPayment == false && orderSuccess.value == 0 && searchParams.get('order_identificator')) {
			let urlId = searchParams.get('order_identificator');
			urlId = urlId.replace("|", '-').replace("|webshoporder", '');

			const webshopOrderId = endpoints.get('_get_hapi_webshop_order');
			const webshopOrder = webshopOrderId.replace("%ID%-%CODE%", urlId);

			async function fetchOrderData() {
				await useApi(webshopOrder, {method: 'GET'})
				.then(async (res) => {
					orderData.value = res.data;

					const order_status_ep = endpoints.get('_get_hapi_webshop_order_status');
					const order_id = (orderData.value?.cart?.order_id) ? orderData.value.cart.order_id + '-' + orderData.value.cart.order_code : null;
					if(!order_id) return useLog('fetchOrderStatus Error: Order code is required', 'error');

					const order_status = order_status_ep.replace("%ID%-%CODE%", order_id)

					async function orderStatus() {
						await useApi(order_status, {method: 'GET'})
						.then(async (res) => {
							const order_ep = endpoints.get('_put_hapi_webshop_order');
							const order = order_ep.replace("%ID%-%CODE%", order_id);

							if(res.data.extra_data_certified_shop == null) {
								setTimeout(() => {
									var smdObject = {
									Key: "Slo_862",
									Type: "order",
									OrderId: "",
									Products: []
									};
									var smdWrapper = document.createElement("script");
									smdWrapper.id = "_cpxTag";
									smdWrapper.type = "text/javascript";
									smdWrapper.src = "https://cpx.smind.si/Log/LogData?data=" + encodeURIComponent(JSON.stringify(smdObject));
									var smdScript = document.getElementsByTagName("script")[0];
									smdScript.parentNode.insertBefore(smdWrapper, smdScript);
								}, 5000);

								await useApi(order, {method: 'PUT', body: {extra_data_certified_shop: true}}, {lang: false});
							}
							if(res.data.extra_data_ec_purchase == null) {
								let gtmShipping = 0
								let gtmCoupon = 0
								if(orderData.value && orderData.value.total.extra_items) {
									orderData.value?.total.extra_items?.find(el => {
										if(el.type == 'shipping') {
											gtmShipping = el.base
										}
										if(el.type == 'coupon') {
											gtmCoupon = el.base
										}
									})
								}
								gtmTrack('purchase', {
									cart: orderData.value,
									'transaction_id': orderData.value.cart?.order_id,
									'value': orderData.value.total?.base + orderData.value.total?.tax,
									'tax': orderData.value.total?.tax,
									'shipping': gtmShipping,
									'coupon': gtmCoupon
								});

								//affiliate lite
								hasCookie('affiliate_lite')
								if(affiliateLite.value) {
									affiliateParameters.CJEVENT = affiliateLite.value;
									let i = 1;
									if (orderData?.value && orderData?.value?.parcels) {
										orderData.value.parcels?.forEach(parcel => {
											if (parcel?.items) {
												parcel?.items?.forEach(product => {
													affiliateParameters[`ITEM${i}`] = product.item.code;
													affiliateParameters[`QTY${i}`] = product.quantity;
													affiliateParameters[`AMT${i}`] = product.base;
													i++;
												});
											}
										});
									}
									affiliateParameters.OID = orderData.value.cart?.order_id;
									affiliateParameters.CURRENCY = 'EUR';
									if(gtmCoupon > 0) {
										affiliateParameters.COUPON = gtmCoupon;
									}

									let requestUrl = 'https://www.emjcd.com/u?';
									requestUrl += new URLSearchParams(affiliateParameters).toString();
									let imgAffiliate = document.createElement('img');
									imgAffiliate.src = requestUrl;
									document?.body?.appendChild(imgAffiliate);
								}

								await useApi(order, {method: 'PUT', body: {extra_data_ec_purchase: true}}, {lang: false});
							}
						})
					}
					orderStatus();
					generateItemImages();
				});
			}

			fetchOrderData();
		}

		if(!searchParams.get('hold') && !searchParams.get('webshopadditionalpayment') && orderData.value && orderData.value.cart.order_id) {
			const order_status_ep = endpoints.get('_get_hapi_webshop_order_status');
			const order_id = orderData.value.cart.order_id + '-' + orderData.value.cart.order_code;
			const order_status = order_status_ep.replace("%ID%-%CODE%", order_id)

			async function orderStatus() {
				await useApi(order_status, {method: 'GET'})
				.then(async (res) => {
					const order_ep = endpoints.get('_put_hapi_webshop_order');
					const order = order_ep.replace("%ID%-%CODE%", order_id);

					if(res.data?.extra_data_certified_shop == null) {
						setTimeout(() => {
							var smdObject = {
							Key: "Slo_862",
							Type: "order",
							OrderId: "",
							Products: []
							};
							var smdWrapper = document.createElement("script");
							smdWrapper.id = "_cpxTag";
							smdWrapper.type = "text/javascript";
							smdWrapper.src = "https://cpx.smind.si/Log/LogData?data=" + encodeURIComponent(JSON.stringify(smdObject));
							var smdScript = document.getElementsByTagName("script")[0];
							smdScript.parentNode.insertBefore(smdWrapper, smdScript);
						}, 5000);

						await useApi(order, {method: 'PUT', body: {extra_data_certified_shop: true}}, {lang: false});
					}
					if(res.data?.extra_data_ec_purchase == null) {
						let gtmShipping = 0
						let gtmCoupon = 0
						if(orderData.value && orderData.value.total.extra_items) {
							orderData.value?.total.extra_items?.find(el => {
								if(el.type == 'shipping') {
									gtmShipping = el.base
								}
								if(el.type == 'coupon') {
									gtmCoupon = el.base
								}
							})
						}
						gtmTrack('purchase', {
							cart: orderData.value,
							'transaction_id': orderData.value.cart?.order_id,
							'value': orderData.value.total?.base + orderData.value.total?.tax,
							'tax': orderData.value.total?.tax,
							'shipping': gtmShipping,
							'coupon': gtmCoupon
						});

						//affiliate lite
						hasCookie('affiliate_lite')
						if(affiliateLite.value) {
							affiliateParameters.CJEVENT = affiliateLite.value;
							let i = 1;
							if (orderData?.value && orderData?.value?.parcels) {
								orderData.value.parcels?.forEach(parcel => {
									if (parcel?.items) {
										parcel?.items?.forEach(product => {
											affiliateParameters[`ITEM${i}`] = product.item.code;
											affiliateParameters[`QTY${i}`] = product.quantity;
											affiliateParameters[`AMT${i}`] = product.base;
											i++;
										});
									}
								});
							}
							affiliateParameters.OID = orderData.value.cart?.order_id;
							affiliateParameters.CURRENCY = 'EUR';
							if(gtmCoupon > 0) {
								affiliateParameters.COUPON = gtmCoupon;
							}

							let requestUrl = 'https://www.emjcd.com/u?';
							requestUrl += new URLSearchParams(affiliateParameters).toString();
							let imgAffiliate = document.createElement('img');
							imgAffiliate.src = requestUrl;
							document?.body?.appendChild(imgAffiliate);
						}

						await useApi(order, {method: 'PUT', body: {extra_data_ec_purchase: true}}, {lang: false});
					}
				})
			}
			orderStatus();
			generateItemImages();
		}

		orderSuccess.value = 0;
	});

	onBeforeUnmount(() => {
		clearInterval(intervalCallOrderStatus);
	});
</script>

<style lang="less" scoped>
	.thank-you-title{
		font-size: 24px; padding: 0 0 16px 35px; font-weight: bold;
		@media (max-width: @m){font-size: 20px;}
		&:before{
			.pseudo(24px,24px); .icon-check(); font: 20px/1 var(--fonti); color: #fff; display: flex; align-items: center; justify-content: center; font-weight: bold; border-radius: 100px; background: var(--blueDark); left: 0; top: 2px;
			@media (max-width: @m){top: -1px;}
		}
	}
	.thank-you-info{
		padding: 10px 0 35px;
		@media (max-width: @m){padding: 10px 0 25px; }
	}
	.thank-you-info-item-label{width: 200px; flex-shrink: 0; flex-grow: 0;}
	.thank-you-info-item{display: flex; padding: 5px 0;}
	
	.thank-you-signup{background: #fff; border-radius: 12px; padding: 16px;}
	.thank-you-signup-title{
		font-size: 18px; font-weight: bold; position: relative; padding: 0 0 10px 32px;
		@media (max-width: @m){font-size: 16px;}
		&:before{
			.pseudo(24px,24px); background: var(--blueDark); border-radius: 100px; left: 0; top: 2px; .icon-user(); font: 13px/1 var(--fonti); color: #fff; display: flex; align-items: center; justify-content: center;
			@media (max-width: @m){top: -1px;}
		}
	}
	.thank-you-signup-content{
		display: flex; justify-content: space-between; gap: 24px; font-size: 15px;
		@media (max-width: @m){flex-direction: column; gap: 12px; font-size: 14px;}
		.btn{min-width: 240px; border-width: 2px;}
		
	}
	.thank-you-continue{
		padding: 32px 0 0; text-align: right;
		.btn{
			min-width: 260px;
			@media (max-width: @m){min-width: 100%;}
		}
	}
	.wc-selected-shippings{
		padding: 32px 0 0;
		@media (max-width: @m){
			.panel{margin: 0; border-radius: 12px;}
		}
	}
	.wc-selected-shippings-title{font-size: 18px; font-weight: bold; padding: 0 0 15px 0;}
	.wc-selected-shippings-content{display: flex; flex-direction: column; gap: 18px;}

	.wc-package{
		font-size: 12px;
		p{padding: 0 0 5px;}
		.wc-package-info{
			padding: 0;
			@media (max-width: @m){padding: 0 0 10px;}
		}
	}
	.wc-package-info{
		color: var(--gray7);
	}
	.wc-package-seller{
		position: absolute; right: 15px; bottom: 15px; color: var(--gray7);
		@media (max-width: @m){position: relative; right: auto; bottom: auto;}
	}

	.thank-you-trr{padding-right: 15px;}
	.thank-you-trr-cnt{
		p:last-child{padding-bottom: 0;}
	}

	.form-loading-bankart{
		padding: 30px 15px; text-align: center; text-wrap: balance;
	}
	.form-loading-bankart-text{
		padding: 20px 0 0;
		p{padding: 0 0 10px;}
	}
</style>
